import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";
import { exportDocument } from "../../helpers/Utils";

export const createTaxFree = async (params) => {
  const key = "createTaxFree";
  try {
    antdAsyncMessageLoading({ key });
    await Axios.post(
      `/api/v1/orders/${params.order_id}/tax_free/`,
      params
    );

    antdAsyncMessageSuccess({ key });
    return { success: true };
  } catch (err) {
    console.log(`${key}: ${err}`);
    antdAsyncMessageError({ key });
    return {
      success: false,
    };
  }
};

export const cancelDeclarationTaxFree = async (order_id) => {
  const key = "cancelDeclarationTaxFree";
  try {
    antdAsyncMessageLoading({ key });
    const { data } = await Axios.post(
      `/api/v1/orders/${order_id}/tax_free/cancel_declaration/`
    );

    if (!data.success) throw new Error("ERR");
    antdAsyncMessageSuccess({ key });
    return { success: true };
  } catch (err) {
    console.log(`${key}: ${err}`);
    antdAsyncMessageError({ key });
    return {
      success: false,
    };
  }
};

export const submitPaymentTaxFree = async (order_id) => {
  const key = "submitPaymentTaxFree";
  try {
    antdAsyncMessageLoading({ key });
    const { data } = await Axios.post(
      `/api/v1/orders/${order_id}/tax_free/submit_payment/`
    );

    if (!data.success) throw new Error("ERR");
    antdAsyncMessageSuccess({ key });
    return { success: true };
  } catch (err) {
    console.log(`${key}: ${err}`);
    antdAsyncMessageError({ key });
    return {
      success: false,
    };
  }
};

export const qrcodeTaxFree = async (order_id) => {
  try {
    await exportDocument(
      `/api/v1/orders/${order_id}/tax_free/qrcode/`,
      `${order_id}_tax_free.pdf`,
      "POST"
    );
  } catch (err) {
    console.log(err);
  }
};
